module.exports = __webpack_public_path__ + "static/popup-starbucks-f520cd09397d71e99aa007cea28d516e.png";